import { useRef } from 'react'

import { Moment } from 'moment'

export const useMinimumLeaveDate = (startsOn: Moment | undefined) => {
  const minDate = useRef<Moment | null | undefined>(undefined)

  minDate.current = startsOn ? startsOn : null

  return minDate
}
